/* LAYOUT COMPONENTS */
import Sidebar from "./sidebar";
import Header from "./header";

const Layout = ({ children }) => {
  return (
    <section className="bg-body overflow-x-hidden p-0 xl:p-3 lg:p-3">
      <div className="container-full-width">
        <div className="block xl:flex lg:flex items-start">
          <div className="hidden xl:block lg:block">
            <Sidebar />
          </div>
          <div className="flex-shrink-0 flex-1">
            <div className="px-0 xl:px-5 lg:px-5">
              <Header />
            </div>
            <div className="h-auto xl:h-mainSection lg:h-mainSection overflow-auto overflow-x-hidden hide-scrollbar">
              {children}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Layout;
